import styled from 'styled-components'

export const RadioPickerWrapper = styled.div`
    .ant-radio-group {
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: nowrap !important;

        .ant-radio-button-wrapper {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            flex-wrap: nowrap;

            height: 32px;
            line-height: 30px;
            font-size: var(--fontsize-14);

            border-color: var(--black-light-385);
            box-sizing: border-box;

            &:first-child {
                border-radius: 6px 0 0 6px;
            }
            &:last-child {
                border-radius: 0 6px 6px 0;
            }
            
            &:hover {
                color: var(--sky-55);
                border-color: var(--sky-5);
                box-shadow: 0 0 0 4px var(--sky-light-285);
            }

            &::before {
                top: 0 !important;
                padding: 0 !important;
                width: 0 !important;
            }

            &.ant-radio-button-wrapper-checked {
                color: var(--white-100);
                background-color: var(--sky-100);
                cursor: default;
            }
        }

        &.ant-radio-group-large {
            .ant-radio-button-wrapper {
                height: 40px;
                line-height: 38px;
                font-size: var(--fontsize-16);
                &:first-child {
                    border-radius: 8px 0 0 8px;
                }
                &:last-child {
                    border-radius: 0 8px 8px 0;
                }
            }
        }
        &.ant-radio-group-small {
            .ant-radio-button-wrapper {
                height: 20px;
                line-height: 18px;
                font-size: var(--fontsize-12);
                &:first-child {
                    border-radius: 4px 0 0 4px !important;
                }
                &:last-child {
                    border-radius: 0 4px 4px 0 !important;
                }
            }
        }

        &.radioImportant {
            .ant-radio-button-wrapper {
                font-size: var(--fontsize-18) !important;
                font-weight: lighter !important;
            }
        }
    }
`

export const SegmentedPickerWrapper = styled.div`
    &:has(> .dataFilterPicker) {
        width: 100% !important;
    }
    .ant-segmented {
        border-radius: 6px;
        .ant-segmented-group {
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            .ant-segmented-thumb {
                transition: var(--transition-normal);
            }
            .ant-segmented-item {
                height: 30px;
                border-radius: 6px;
                .ant-typography {
                    font-family: 'Arial Narrow' !important;
                }
            }
        }
        &.ant-segmented-lg {
            .ant-segmented-group {
                .ant-segmented-item {
                    height: 34px;
                }
            }
        }
        &.ant-segmented-sm {
            .ant-segmented-group {
                .ant-segmented-item {
                    height: 27px !important;
                }
            }
        }
        /* 默认选择器 */
        &.defaultPicker {
            background: var(--white-100);
            border: 1px solid var(--sky-5);
            .ant-segmented-group {
                justify-content: center;
                align-items: center;
                .ant-segmented-item {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    min-width: var(--wh-98);
                    .ant-typography {
                        font-family: 'Arial Narrow';
                    }
                    .icon-svg {
                        /* 为图标视觉水平居中而设置的特殊定位 无全局意义 */
                        margin-top: -2px;
                        color: var(--black-25);
                        fill: var(--black-25);
                        font-size: var(--fontsize-16);
                    }
                    .ant-segmented-item-label {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        overflow: visible;
                        padding: 0 12px;
                        font-size: var(--fontsize-14);

                        .ant-badge {
                            transition: var(--transition-normal);
                            .ant-badge-count {
                                opacity: .75;
                            }
                            .ant-typography {
                                color: var(--font-85);
                            }
                        }

                        .ant-badge-count {
                            transform: translate(calc(100% +  4px), calc(-100% + 2px)) !important;
                            background: radial-gradient(circle, var(--tomato-100) 0, var(--tomato-100) 35%, var(--tomato-15) 100%);
                            box-shadow: 0 0 4px var(--white-85);
                            font-size: var(--fontsize-10);
                        }
                    }
                    &.ant-segmented-item-selected {
                        .ant-segmented-item-label {
                            .ant-badge {
                                .ant-badge-count {
                                    opacity: 1;
                                }
                                .ant-typography {
                                    color: var(--white-100);
                                }
                            }

                        }
                    }
                    &:hover {
                        .icon-svg {
                            color: var(--sky-25);
                            fill: var(--sky-25);
                        }
                        .ant-segmented-item-label {
                            color: var(--sky-85);
                        }
                    }
                    &.ant-segmented-item-selected {
                        background-color: var(--sky-100);
                        .icon-svg {
                            color: var(--white-55);
                            fill: var(--white-55);
                        }
                        .ant-segmented-item-label {
                            color: var(--white-100);
                        }
                        &:hover .icon-svg {
                            color: var(--white-100);
                            fill: var(--white-100);
                        }
                        &:hover .ant-segmented-item-label {
                            color: var(--white-100);
                        }
                    }
                    &.ant-segmented-item-disabled {
                        .icon-svg,
                        &:hover .icon-svg {
                            color: var(--black-15);
                            fill: var(--black-15);
                        }
                        .ant-segmented-item-label,
                        &:hover .ant-segmented-item-label {
                            color: var(--black-15);
                        }
                    }
                    &.ant-segmented-item-selected.ant-segmented-item-disabled {
                        background-color: var(--sky-75);
                        .icon-svg,
                        &:hover .icon-svg {
                            color: var(--white-35);
                            fill: var(--white-35);
                        }
                        .ant-segmented-item-label,
                        &:hover .ant-segmented-item-label {
                            color: var(--white-35);
                        }
                    }
                }
            }
            &.withBadge {
                .ant-segmented-group {
                    >.ant-segmented-item {
                        margin-right: 12px;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
            }
        }
        /* 日月平铺选择器 */
        &.datePicker {
            background: transparent;
            border: none; 
            border-radius: 8px;
            padding: 0 12px;
            .ant-segmented-group {
                .ant-segmented-thumb {}
                .ant-segmented-item {
                    display: flex;
                    justify-content: center;
                    align-items: center;  
                    
                    border-radius: 50%;
                    border: none;
                    box-sizing: border-box;

                    width: 36px;
                    height: 36px;
                    
                    .ant-segmented-item-label {
                        transition: var(--transition-faster);
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        box-sizing: border-box;

                        width: 36px;
                        height: 36px;
                    }
                    &:hover {
                        .ant-segmented-item-label {
                            color: var(--black-85);
                            transform: var(--size-x-larger);
                        }
                    }
                    &.ant-segmented-item-selected {
                        background-color: var(--sky-100);
                        box-shadow: 0 0 8px var(--sky-85);
                        .ant-segmented-item-label {
                            color: var(--white-100);
                            font-weight: 0;
                            transform: var(--size-x-larger);
                        }
                        &:hover {
                            .ant-segmented-item-label {
                                color: var(--white-100);
                            }
                        }
                    }
                    &.ant-segmented-item-disabled {
                        .ant-segmented-item-label,
                        &:hover .ant-segmented-item-label {
                            color: var(--black-15);
                            transform: var(--size-normal);
                        }
                    }
                    &.ant-segmented-item-selected.ant-segmented-item-disabled {
                        background: var(--sky-75);
                        .ant-segmented-item-label,
                        &:hover .ant-segmented-item-label {
                            color: var(--white-35);
                            transform: var(--size-normal);
                        }
                    }
                }
            }
            /* 日选择器 */
            &.pickerDay {
                .ant-segmented-group {
                    /* 日的切换动画样式 */
                    .ant-segmented-thumb {
                        border-color: transparent;
                        border-radius: 50%;
                        background: radial-gradient(circle, var(--sky-585) calc(100% - 32px), var(--sky-light-185) 100%);
                        box-shadow: none;
                    }
                    .ant-segmented-item {
                        .ant-segmented-item-label {
                            font-size: var(--fontsize-14);
                        }
                    }
                }
                &.ant-segmented-sm {
                    .ant-segmented-group {
                        .ant-segmented-item {
                            width: 27px !important;
                        }
                    }
                }
                /* 设备报表里的日选择器自适应 */
                &.deviceReportDatePicker {                 
                    &.day28 {
                        &.opened {
                            .ant-segmented-thumb {
                                @media (max-width: 1536px) {
                                    border-radius: 8px !important;
                                    background: linear-gradient(90deg, var(--sky-585), var(--sky-0)) !important;
                                }
                            }
                        }
                        &.collapsed {
                            .ant-segmented-thumb {
                                @media (max-width: 1366px) {
                                    border-radius: 8px !important;
                                    background: linear-gradient(90deg, var(--sky-585), var(--sky-0)) !important;
                                }
                            }
                        }
                    }
                    &.day29 {
                        &.opened {
                            .ant-segmented-thumb {
                                @media (max-width: 1579px) {
                                    border-radius: 8px !important;
                                    background: linear-gradient(90deg, var(--sky-585), var(--sky-0)) !important;
                                }
                            }
                        }
                        &.collapsed {
                            .ant-segmented-thumb {
                                @media (max-width: 1408px) {
                                    border-radius: 8px !important;
                                    background: linear-gradient(90deg, var(--sky-585), var(--sky-0)) !important;
                                }
                            }
                        }
                    }
                    &.day30 {
                        &.opened {
                            .ant-segmented-thumb {
                                @media (max-width: 1622px) {
                                    border-radius: 8px !important;
                                    background: linear-gradient(90deg, var(--sky-585), var(--sky-0)) !important;
                                }
                            }
                        }
                        &.collapsed {
                            .ant-segmented-thumb {
                                @media (max-width: 1452px) {
                                    border-radius: 8px !important;
                                    background: linear-gradient(90deg, var(--sky-585), var(--sky-0)) !important;
                                }
                            }
                        }
                    }
                    &.day31 {
                        &.opened {
                            .ant-segmented-thumb {
                                @media (max-width: 1665px) {
                                    border-radius: 8px !important;
                                    background: linear-gradient(90deg, var(--sky-585), var(--sky-0)) !important;
                                }
                            }
                        }
                        &.collapsed {
                            .ant-segmented-thumb {
                                @media (max-width: 1495px) {
                                    border-radius: 8px !important;
                                    background: linear-gradient(90deg, var(--sky-585), var(--sky-0)) !important;
                                }
                            }
                        }
                    }
                }
            }
            /* 月选择器 */
            &.pickerMonth {
                .ant-segmented-group {
                    /* 月的切换动画样式 */
                    .ant-segmented-thumb {
                        border-color: transparent;
                        border-radius: 50%;
                        background: radial-gradient(circle, var(--sky-585) calc(100% - 32px), var(--sky-light-185) 100%);
                        box-shadow: none;
                        @media (max-width: 483px) {
                            border-radius: 8px !important;
                            background: linear-gradient(90deg, var(--sky-585), var(--sky-0)) !important;
                        }
                    }
                    .ant-segmented-item {
                        .ant-segmented-item-label {                          
                            font-size: var(--fontsize-18);
                        }
                    }
                }
                /* 设备报表里的月选择器自适应 */
                &.deviceReportDatePicker {                 
                    .ant-segmented-thumb {
                        @media (max-width: 503px) {
                            border-radius: 8px !important;
                            background: linear-gradient(90deg, var(--sky-585), var(--sky-0)) !important;
                        }
                    }
                }
            }
        }
        /* 报警类型选择器 */
        &.alarmTypePicker {
            height: 36px;
            border-radius: 36px;
            background-color: var(--black-light-185);
            .ant-segmented-group {
                flex-wrap: wrap;
                .ant-segmented-thumb {
                    border-radius: 36px;
                    background: var(--black-light-285);
                    box-shadow: inset 0 0 8px var(--white-100) !important;
                }
                .ant-segmented-item {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    min-width: var(--wh-98);
                    height: 32px;
                    border-radius: 32px;

                    .ant-typography {
                        color: var(--font-85);
                        font-weight: 600;
                    }
                    .ant-badge {
                        cursor: pointer;
                    }

                    &:hover {
                        background: var(--black-light-185);
                        box-shadow: inset 0 0 8px var(--white-100) !important;
                    }

                    &.ant-segmented-item-selected {
                        transition: var(--transition-normal);
                        .ant-typography {
                            color: var(--white-100);
                            font-weight: normal;
                            transition: var(--transition-normal);
                        }
                        .ant-badge-status-dot {
                            background-color: var(--white-55);
                            transition: var(--transition-normal);
                            &::after {
                                border: 2px solid var(--white-75);
                            }
                        }
                        // 报警类型：离线
                        &:nth-child(1) {
                            background-color: var(--offline-color) !important;
                        }
                        // 报警类型：故障
                        &:nth-child(2) {
                            background-color: var(--failure-color) !important;
                        }
                        // 报警类型：通讯异常
                        &:nth-child(3) {
                            background-color: var(--loggerOffline-color) !important;
                        }
                        // 报警类型：阈值报警
                        &:nth-child(4) {
                            background-color: var(--thresholdAlarm-color) !important;
                        }
                        &:hover {
                            box-shadow: inset 0 0 8px var(--white-0) !important;
                            .ant-typography {
                                color: var(--white-85);
                            }
                            .ant-badge-status-dot {
                                background-color: var(--white-85);
                                transition: var(--transition-normal);
                                &::after {
                                    border: 2px solid var(--white-100);
                                }
                            }
                        }
                    }
                }
            }
        }
        /* 设备类型选择器 */
        &.deviceTypePicker {
            background-color: var(--black-0);
            border: none;
            &.fullWidth {
                .ant-segmented-item-label {
                    min-width: 52px;
                }
                @media (max-width: 768px) {
                    .ant-segmented-item-label {
                        min-width: 0;
                    }
                }
            }
            .ant-segmented-group {
                // background-color: var(--black-light-185);
                flex-wrap: wrap;
                justify-content: center;
                align-items: center;
                >.ant-segmented-thumb {
                    background: var(--white-85);
                    box-shadow: inset 0 0 8px var(--white-100);
                }
                >.ant-segmented-item {
                    background-color: var(--black-light-185);
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    .icon-svg {
                        color: var(--black-15);
                        fill: var(--black-15);

                        font-size: var(--fontsize-14);

                        margin-top: -1px;
                    }
                    .ant-segmented-item-label {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: var(--font-55);
                         .icon-svg {
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;

                            font-size: var(--fontsize-12);
                            min-width: 16px;                           
                            transition: var(--transition-faster);
                            opacity: .55;

                            //离线
                            &.deviceFlag1{
                                color: var(--deviceOffline-color);
                                fill: var(--deviceOffline-color);
                            }
                            //故障  
                            &.deviceFlag4{ 
                                color: var(--failure-color);
                                fill: var(--failure-color);
                            }
                            //停机 
                            &.deviceFlag3{
                                // color: var(--shutDown-color);
                                // fill: var(--shutDown-color);
                                 color: var(--normal-color);
                                fill: var(--normal-color);
                            }
                            //正常 
                            &.deviceFlag0 {
                                color: var(--normal-color);
                                fill: var(--normal-color);
                            }
                        }
                    }
                    &:hover {
                        .icon-svg {
                            color: var(--black-25);
                            fill: var(--black-25);
                        }
                        .ant-segmented-item-label {
                            color: var(--font-85);
                        }
                    }
                    &.ant-segmented-item-selected {
                        background-color: var(--sky-100);
                        .icon-svg {
                            color: var(--white-55);
                            fill: var(--white-55);
                        }
                        .ant-segmented-item-label {
                            color: var(--white-100);
                        }
                        &:hover .icon-svg {
                            color: var(--white-100);
                            fill: var(--white-100);
                        }
                        &:hover .ant-segmented-item-label {
                            color: var(--white-100);
                        }
                    }
                    &.ant-segmented-item-disabled {
                        .icon-svg,
                        &:hover .icon-svg {
                            color: var(--black-15);
                            fill: var(--black-15);
                        }
                        .ant-segmented-item-label,
                        &:hover .ant-segmented-item-label {
                            color: var(--black-15);
                        }
                    }
                    &.ant-segmented-item-selected.ant-segmented-item-disabled {
                        background-color: var(--sky-75);
                        .icon-svg,
                        &:hover .icon-svg {
                            color: var(--white-35);
                            fill: var(--white-35);
                        }
                        .ant-segmented-item-label,
                        &:hover .ant-segmented-item-label {
                            color: var(--white-35);
                        }
                    }
                }
            }
        }


        /* 数据筛选选择器 */
        &.dataFilterPicker {
            background-color: var(--black-0);
            border: none;
            width: 100%;
            .ant-segmented-group {
                flex-wrap: nowrap;
                justify-content: center;
                align-items: center;
                >.ant-segmented-thumb {
                    background: var(--white-85);
                    box-shadow: inset 0 0 8px var(--white-100);
                }
                >.ant-segmented-item {
                    flex: 1 1 0;
                    min-width: 0;
                    background-color: var(--black-light-185);
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    .icon-svg {
                        color: var(--black-15);
                        fill: var(--black-15);

                        font-size: var(--fontsize-14);

                        margin-top: -1px;
                    }
                    .ant-segmented-item-label {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: var(--font-55);
                         .icon-svg {
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;

                            font-size: var(--fontsize-12);
                            min-width: 16px;                           
                            transition: var(--transition-faster);
                            opacity: .55;
                        }
                    }
                    &:hover {
                        .icon-svg {
                            color: var(--black-25);
                            fill: var(--black-25);
                        }
                        .ant-segmented-item-label {
                            color: var(--font-85);
                        }
                    }
                    &.ant-segmented-item-selected {
                        background-color: var(--sky-100);
                        .icon-svg {
                            color: var(--white-55);
                            fill: var(--white-55);
                        }
                        .ant-segmented-item-label {
                            color: var(--white-100);
                        }
                        &:hover .icon-svg {
                            color: var(--white-100);
                            fill: var(--white-100);
                        }
                        &:hover .ant-segmented-item-label {
                            color: var(--white-100);
                        }
                    }
                    &.ant-segmented-item-disabled {
                        .icon-svg,
                        &:hover .icon-svg {
                            color: var(--black-15);
                            fill: var(--black-15);
                        }
                        .ant-segmented-item-label,
                        &:hover .ant-segmented-item-label {
                            color: var(--black-15);
                        }
                    }
                    &.ant-segmented-item-selected.ant-segmented-item-disabled {
                        background-color: var(--sky-75);
                        .icon-svg,
                        &:hover .icon-svg {
                            color: var(--white-35);
                            fill: var(--white-35);
                        }
                        .ant-segmented-item-label,
                        &:hover .ant-segmented-item-label {
                            color: var(--white-35);
                        }
                    }
                }
            }
        }





        /* 采集器选择器 */
        &.collectorPicker {
            background: transparent !important;
            padding-left: 24px !important;
            padding-right: 24px !important;
            .ant-segmented-group {
                flex-wrap: wrap;
                align-items: center;
                justify-content: center;
                >.ant-segmented-thumb {
                    border-radius: 12px;
                    background: var(--white-85);
                    box-shadow: inset 0 0 8px var(--white-100);
                }
                >.ant-segmented-item {
                    border-radius: 12px;
                    height: var(--wh-88);
                    transition: var(--transition-x-faster);

                    .ant-avatar {
                        border: none;
                        /* 采集器图标特定定位样式 换图标需重新调整定位样式 */
                        .icon-svg {
                            width: 100%;
                            >div>svg {
                                margin-top: -2px;
                            }
                        }
                    }
                    
                    .ant-segmented-item-label {
                        min-width: 54px;
                        padding: 12px 8px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        opacity: .45;
                        overflow: visible;
                        .ant-space>.ant-space-item {
                            .ant-typography {
                                font-size: var(--fontsize-12) !important;
                            }
                        }

                        .ant-ribbon.loggerSwitch {
                            top: 4px !important;
                            border-radius: 50% !important;
                            width: 24px !important;
                            min-width: 24px !important;
                            height: 24px !important;
                            
                            .ant-ribbon-text {
                                display: flex !important;
                                flex-direction: row !important;
                                justify-content: center !important;
                                align-items: center !important;
                            }
                        }

                        .ant-space.loggerCard {
                            /* 采集器 基础设备 */
                            .default,
                            .master {
                                .ant-avatar {
                                    transform: var(--size-larger);
                                }
                            }
                            /* 采集器 冗余设备 */
                            .redundant {
                                .ant-avatar {
                                    transform: var(--size-small);
                                }
                            }
                            .online .ant-avatar {
                                .icon-svg {
                                    color: var(--loggerOnline-color);
                                    fill: var(--loggerOnline-color);
                                    background: radial-gradient(circle, var(--white-100) calc(100% - 24px), var(--loggerOnline-light-color) 100%);
                                }
                            }
                            .offline .ant-avatar {
                                .icon-svg {
                                    color: var(--loggerOffline-color);
                                    fill: var(--loggerOffline-color);
                                    background: radial-gradient(circle, var(--white-100) calc(100% - 16px), var(--loggerOffline-light-color) 100%);
                                }
                            }
                        }
                    }

                    &.ant-segmented-item-selected {
                        background-color: var(--white-100);
                        .ant-segmented-item-label {
                            opacity: 1;
                            >.ant-space.loggerCard {
                                /* 采集器 选中状态 */
                                .online {
                                    .ant-avatar {
                                        box-shadow: 0 0 8px var(--loggerOnline-color);
                                    }
                                }
                                .offline {
                                    .ant-avatar {
                                        box-shadow: 0 0 8px var(--loggerOffline-color);
                                    }
                                }
                            }
                            .ant-space {
                                .ant-space-item {
                                    &:nth-child(2) {
                                        opacity: 0;
                                    }
                                    &:nth-child(3) {
                                        margin-top: -34px;
                                        opacity: 1;
                                        cursor: none;
                                    }
                                }
                            }
                        }
                        /* 选中状态下的各种输入框样式 */
                        .ant-input {
                            color: var(--font-85) !important;
                        }
                        .ant-input-affix-wrapper-disabled {
                            .ant-input-suffix {
                                width: 0;
                                display: none;
                            }
                        }
                    }
                    &:hover,
                    &.ant-segmented-item-selected:hover {
                        .ant-segmented-item-label {
                            opacity: 1;
                        }
                    }               
                }
            }

            /* 输入框样式 */
            .ant-input-affix-wrapper>.ant-input,  
            .ant-input-affix-wrapper.ant-input-affix-wrapper-disabled:hover>.ant-input {
                text-align: center;

                box-sizing: border-box;
                
                font-family: 'Arial Narrow';
                font-size:  var(--fontsize-12) !important;
                letter-spacing: var(--spacing-large);

                height: 26px;
            }

            .ant-input-affix-wrapper:hover>.ant-input,
            .ant-input-affix-wrapper.ant-input-affix-wrapper-focused>.ant-input,  
            .ant-form-item-has-error .ant-input-affix-wrapper-status-error .ant-input {
                text-align: center;
            }

            .ant-input-affix-wrapper.ant-input-affix-wrapper-focused>.ant-input,  
            .ant-form-item-has-error .ant-input-affix-wrapper-status-error .ant-input {
                font-size:  var(--fontsize-12) !important;
            }

            .ant-input-affix-wrapper.ant-input-affix-wrapper-focused>.ant-input,
            .ant-form-item-has-error .ant-input {
                letter-spacing: var(--spacing-normal) !important;
            }

            .ant-form-item-has-error {
                .ant-input-affix-wrapper {
                    &.ant-input-affix-wrapper-status-error {
                        border: 1px solid var(--tomato-15) !important;
                        color: var(--tomato-85) !important;
                        &.ant-input-affix-wrapper-focused {
                            border: 1px solid var(--tomato-85) !important;
                        }
                    }
                }
                .ant-form-item-control>div:last-child {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    position: absolute;
                    padding: 0 0 0 7px;
                    height: 32px;

                    .ant-form-item-explain-error {
                        color: var(--tomato-35) !important;
                        font-size: var(--fontsize-10) !important;
                    }
                }
            }
            
            /* 输入框尾部编辑图标的样式 */
            .ant-input-suffix {
                transition: var(--transition-normal);

                color: var(--sky-35);
                opacity: 1;
                
                margin: 0;

                .anticon.anticon-edit {
                    margin: 0 -7px 0 0;
                }

                >.icon-svg svg {
                    transition: var(--transition-normal);
                    fill: var(--sky-15);
                }
            }

            .ant-input-affix-wrapper {
                color: var(--font-85);
                border-color: transparent !important;
                background-color: transparent !important;

                padding: 0 7px 0 20px;
                resize: none;

                >.ant-input {
                    padding: 0 !important;
                }

                &:hover {
                    border-color: var(--sky-5) !important;
                    .ant-input-suffix>.icon-svg svg {
                        fill: var(--sky-35);
                    }
                }

                &.ant-input-affix-wrapper-focused {
                    border-color: var(--sky-100) !important;
                    .ant-input-suffix>.icon-svg svg {
                        fill: var(--sky-100);
                    }
                }
            }
            
            .ant-input.ant-input-status-error,
            .ant-input-affix-wrapper.ant-input-affix-wrapper-status-error {
                border-color: transparent !important;
            }

            .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
                font-size:  var(--fontsize-12);
                padding: 0;
            }
        }     
       
        /* 设备选择器&调频时段选择器 */
        &.devicePicker {
            border-radius: 12px;
            background: transparent;
            padding: 0 24px;
            min-width: var(--wh-568);
            @media (max-width: 768px) {
                min-width: var(--percent-100);
            }
            
            .ant-segmented-group {
                >.ant-segmented-thumb {
                    border-radius: 34px;
                    border-color: transparent;
                    background: linear-gradient(90deg, var(--white-55), var(--white-0));
                    box-shadow: none;
                }
                >.ant-segmented-item {
                    height: 34px;
                    border-radius: 34px;
                    >.ant-segmented-item-label {
                        display: flex;
                        justify-content: start;
                        align-items: center;

                        width: var(--wh-fit);
                        min-width: var(--wh-188);
                        max-width: var(--wh-188);
                        height: 34px;

                        border-color: transparent;
                        box-sizing: border-box;
                        padding: 0 7px !important;
                        overflow: hidden;

                        opacity: .75;

                        .icon-svg {
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;

                            font-size: var(--fontsize-12);
                            min-width: 16px;                           
                            transition: var(--transition-faster);
                            opacity: .55;

                            //离线
                            &.deviceFlag1{
                                color: var(--deviceOffline-color);
                                fill: var(--deviceOffline-color);
                            }
                            //故障  
                            &.deviceFlag4{ 
                                color: var(--failure-color);
                                fill: var(--failure-color);
                            }
                            //停机 
                            &.deviceFlag3{
                                // color: var(--shutDown-color);
                                // fill: var(--shutDown-color);
                                 color: var(--normal-color);
                                fill: var(--normal-color);
                            }
                            //正常 
                            &.deviceFlag0 {
                                color: var(--normal-color);
                                fill: var(--normal-color);
                            }
                        }
                        >.ant-typography {
                            margin-left: 4px;
                            color: var(--font-100);
                            font-size: var(--fontsize-12);
                            transition: var(--transition-normal);
                        }
                    }
                    &:hover {
                        .ant-segmented-item-label {
                            opacity: 1;
                            .icon-svg {
                                opacity: 1;
                            }
                            >.ant-typography {
                                letter-spacing: var(--spacing-x-larger);
                            }
                        }
                    }
                    
                    &.ant-segmented-item-selected {
                        border-left: 1px solid var(--sky-35);
                        background: linear-gradient(90deg, var(--white-100), var(--white-0));
                        box-shadow: -12px 0 12px var(--sky-585);
                        .ant-segmented-item-label {
                            opacity: 1;
                            .icon-svg {
                                font-size: var(--fontsize-14);
                                opacity: 1;
                            }
                            .ant-typography {
                                margin-left: 4px;
                                font-size: var(--fontsize-14);
                                letter-spacing: var(--spacing-larger);
                            }
                        }
                        &:hover {
                            border-left: 1px solid var(--sky-85);
                            box-shadow: -12px 0 12px var(--sky-885);
                            .ant-segmented-item-label {
                                .icon-svg {
                                    opacity: 1;
                                }
                                .ant-typography {
                                    letter-spacing: var(--spacing-larger);
                                }
                            }
                        }
                    }

                    &.ant-segmented-item-disabled,
                    &.ant-segmented-item-disabled:hover,
                    &.ant-segmented-item-disabled:focus {
                        cursor: not-allowed;
                        >.ant-segmented-item-label {
                            opacity: .15 !important;
                            >.icon-svg {
                                font-size: var(--fontsize-12) !important;
                            }
                            >.ant-typography {
                                margin-left: 0 !important;
                                font-size: var(--fontsize-12) !important;
                                letter-spacing: var(--spacing-normal) !important;
                            }
                        }
                    }

                    /* 选择器内的下拉框的样式 */
                    .ant-select {
                        &.ant-select-single {
                            width: fit-content;
                            min-width: var(--wh-48);
                            border-color: transparent;
                            .ant-select-selector {
                                border: none;
                                padding: 0;
                                box-sizing: border-box;
                                box-shadow: none;
                                height: 34px;
                                >span.ant-select-selection-item {
                                    margin-left: 4px;
                                    line-height: 34px;
                                    transition: var(--transition-faster);
                                }
                            }
                            &.ant-select-show-arrow {
                                >span.ant-select-selection-item {
                                    font-size:  var(--fontsize-12);
                                    text-align: left;
                                }
                                >span.ant-select-arrow {
                                    color: var(--font-35);
                                    transform: var(--size-x-smaller);
                                }
                                &.ant-select-open {
                                    >.ant-select-selector {
                                        >span.ant-select-selection-item {
                                            color: var(--font-85);
                                        }
                                    }
                                }
                            }
                        }
                    }

                    &.ant-segmented-item-selected {
                        .ant-select {
                            span.ant-select-selection-item {
                                font-size:  var(--fontsize-14);
                                letter-spacing: var(--spacing-larger);
                            }
                        }
                        &:hover {
                            span.ant-select-arrow {
                                color: var(--sky-55) !important;
                                transition: var(--transition-normal) !important;
                            }

                            .ant-select {
                                &.ant-select-single {
                                    &.ant-select-show-arrow {
                                        .ant-select-selector {
                                            >span.ant-select-selection-item {
                                                letter-spacing: var(--spacing-larger);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    &:hover {
                        .ant-select {
                            &.ant-select-single {
                                &.ant-select-show-arrow {
                                    .ant-select-selector {
                                        >span.ant-select-selection-item {
                                            letter-spacing: var(--spacing-x-larger);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            &.bgWhiteSegmented {
                .ant-segmented-group {
                    >.ant-segmented-thumb {
                        background: linear-gradient(90deg, var(--sky-light-185), var(--sky-0));
                    }
                }
            }
`

export const TabPickerWrapper = styled.div`
    &:has(> .pfcDurationPicker) {
        height: var(--wh-48);
        overflow: hidden;

        .ant-tabs {
            line-height: normal;
            .ant-tabs-nav:before {
                opacity: 0 !important;
            }
            .ant-tabs-tab {
                opacity: 0.75 !important;
                &.ant-tabs-tab-active {
                    opacity: 1 !important;
                }
            }
            /* Tabs组件选项下划线透明度为0 */
            .ant-tabs-ink-bar {
                opacity: 0;
            }
        }
    }

    &:has(> .marketTypePicker) {
        display: flex;
        justify-content: flex-start;

        .ant-tabs {
            width: fit-content;

            .ant-tabs-ink-bar,
            .ant-tabs-content-holder {
                opacity: 0;
            }

            .ant-tabs-tab {
                margin: 0;
                padding: 4px;
                font-size: var(--fontsize-16) ;
                display: inline-flex;
                align-items: center;
                gap: 8px;

                &::before {
                    content: '';
                    display: inline-block;
                    width: 4px;
                    height: 16px;
                    border-radius: 4px;
                    background: var(--sky-35);
                    opacity: 0.55;
                    transition: var(--transition-normal);
                }

                &.ant-tabs-tab-active::before {
                    background: var(--sky-100);
                    opacity: 1;
                }
            }
        }
    }
`